import { jsx as _jsx } from "react/jsx-runtime";
import 'react-circular-progressbar/dist/styles.css';
import { colors } from '@getgo/chameleon-core';
import { buildStyles, CircularProgressbarWithChildren as ReactCircularProgressbar, } from 'react-circular-progressbar';
export const CircularProgressbar = ({ value, text, pathColor = colors.blue.b500, textColor = colors.blue.b500, trailColor = colors.blue.b300, strokeLinecap = 'butt', strokeWidth = 8, children, }) => {
    return (_jsx(ReactCircularProgressbar, Object.assign({ value: value, text: children ? null : text, strokeWidth: strokeWidth, styles: buildStyles({
            strokeLinecap,
            pathColor,
            trailColor,
            textColor,
        }) }, { children: children }), void 0));
};
export default CircularProgressbar;
//# sourceMappingURL=index.js.map